export default __webpack_public_path__ + "static/Map_upside-down-575c44819d201ab07c5310903f869f09.png";